
import { Component, Vue } from 'vue-property-decorator'

import OrderHistoryComponent from '@/components/OrderHistory.vue';
import SingleOrder from '@/components/SingleOrder.vue';
import UserModule from '@/store/modules/user';

@Component({
  components: {
    'order-history': OrderHistoryComponent,
    SingleOrder
  }
})
export default class RewardHistory extends Vue {
  get rewardHistory(): AccountEventModel[] {
    return UserModule.rewardHistory;
  }

  get customerPoints() {
    return UserModule.currentPoints;
  }

  get numberOfPointsText(): string {
    const points = UserModule.currentPoints;
    if (points === 1) {
      return 'point';
    }
    return 'points';
  }

  parsedRewardDate(input): string {
    return new Date(input).toLocaleDateString('en-US');
  }

  rewardClasses(index: number): string {
    if (index === 0) {
      return 'border-t border-r border-l border-b border-brandGray-med flex justify-between p-4';
    }
    return 'border-r border-l border-b border-brandGray-med flex justify-between p-4';
  }

  rewardTitle(reward: AccountEventModel): string {
    // Add business logic if needed
    return reward.title;
  }

  rewardPointText(reward: AccountEventModel): string {
    if (reward.title.toUpperCase() === 'ITEM GIFTED') {
      return '+1';
    }
    if (reward.title.toUpperCase() === 'REWARDS REDEEMED') {
      return `-${reward.points}`
    }
    return `${reward.points}`;
  }
}
